import React, { useState } from 'react';
import Button from '../ui/Button';
import Alert from '../ui/Alert';
const AdmissionForm = () => {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setFormStatus('submitting');
    // Simulate form submission
    setTimeout(() => {
      // 90% chance of success for demo purposes
      if (Math.random() > 0.1) {
        setFormStatus('success');
      } else {
        setFormStatus('error');
      }
    }, 1500);
  };
  return <div className="bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-129">
      <div className="bg-blue-900 text-white p-6" data-id="element-130">
        <h3 className="text-xl font-bold" data-id="element-131">Start Your Application</h3>
        <p className="text-blue-100 mt-1" data-id="element-132">
          Fill out the form below to begin your admission process
        </p>
      </div>
      <div className="p-6" data-id="element-133">
        {formStatus === 'success' && <Alert variant="success" title="Application Submitted Successfully!" className="mb-6" data-id="element-134">
            Thank you for your interest in Isonyin Grammar School. We have
            received your application and will contact you shortly with next
            steps.
          </Alert>}
        {formStatus === 'error' && <Alert variant="error" title="Submission Error" className="mb-6" dismissible data-id="element-135">
            There was a problem submitting your application. Please try again or
            contact our admissions office directly.
          </Alert>}
        <form onSubmit={handleSubmit} className={formStatus === 'success' ? 'hidden' : ''} data-id="element-136">
          <div className="space-y-6" data-id="element-137">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-138">
              <div data-id="element-139">
                <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-140">
                  First Name <span className="text-red-500" data-id="element-141">*</span>
                </label>
                <input type="text" id="firstName" name="firstName" required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-142" />
              </div>
              <div data-id="element-143">
                <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-144">
                  Last Name <span className="text-red-500" data-id="element-145">*</span>
                </label>
                <input type="text" id="lastName" name="lastName" required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-146" />
              </div>
            </div>
            <div data-id="element-147">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-148">
                Email Address <span className="text-red-500" data-id="element-149">*</span>
              </label>
              <input type="email" id="email" name="email" required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-150" />
            </div>
            <div data-id="element-151">
              <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-152">
                Phone Number <span className="text-red-500" data-id="element-153">*</span>
              </label>
              <input type="tel" id="phone" name="phone" required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-154" />
            </div>
            <div data-id="element-155">
              <label htmlFor="studentClass" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-156">
                Applying for Class <span className="text-red-500" data-id="element-157">*</span>
              </label>
              <select id="studentClass" name="studentClass" required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-158">
                <option value="" data-id="element-159">Select a class</option>
                <option value="JSS1" data-id="element-160">JSS 1</option>
                <option value="JSS2" data-id="element-161">JSS 2</option>
                <option value="JSS3" data-id="element-162">JSS 3</option>
                <option value="SS1" data-id="element-163">SS 1</option>
                <option value="SS2" data-id="element-164">SS 2</option>
                <option value="SS3" data-id="element-165">SS 3</option>
              </select>
            </div>
            <div data-id="element-166">
              <label htmlFor="previousSchool" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-167">
                Previous School (if applicable)
              </label>
              <input type="text" id="previousSchool" name="previousSchool" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-168" />
            </div>
            <div data-id="element-169">
              <label htmlFor="howHeard" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-170">
                How did you hear about us?
              </label>
              <select id="howHeard" name="howHeard" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-171">
                <option value="" data-id="element-172">Please select</option>
                <option value="website" data-id="element-173">School Website</option>
                <option value="socialMedia" data-id="element-174">Social Media</option>
                <option value="friend" data-id="element-175">Friend or Family</option>
                <option value="newspaper" data-id="element-176">Newspaper</option>
                <option value="event" data-id="element-177">School Event</option>
                <option value="other" data-id="element-178">Other</option>
              </select>
            </div>
            <div data-id="element-179">
              <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-180">
                Additional Information
              </label>
              <textarea id="message" name="message" rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="Please share any additional information that may be relevant to your application" data-id="element-181"></textarea>
            </div>
            <div className="flex items-start" data-id="element-182">
              <div className="flex items-center h-5" data-id="element-183">
                <input id="terms" name="terms" type="checkbox" required className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500" data-id="element-184" />
              </div>
              <div className="ml-3 text-sm" data-id="element-185">
                <label htmlFor="terms" className="font-medium text-gray-700" data-id="element-186">
                  I agree to the{' '}
                  <a href="#" className="text-blue-600 hover:underline" data-id="element-187">
                    terms and conditions
                  </a>{' '}
                  <span className="text-red-500" data-id="element-188">*</span>
                </label>
              </div>
            </div>
            <div data-id="element-189">
              <Button type="submit" variant="primary" size="lg" fullWidth loading={formStatus === 'submitting'} disabled={formStatus === 'submitting'} data-id="element-190">
                {formStatus === 'submitting' ? 'Submitting...' : 'Submit Application'}
              </Button>
            </div>
          </div>
        </form>
        {formStatus === 'success' && <div className="text-center mt-4" data-id="element-191">
            <Button variant="outline" onClick={() => {
          setFormStatus('idle');
          // Reset form here if needed
        }} data-id="element-192">
              Submit Another Application
            </Button>
          </div>}
      </div>
    </div>;
};
export default AdmissionForm;